import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";
import MDButton from "components/MDButton";
import MDProgress from "components/MDProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { styled } from "@mui/system";
import colors from "assets/theme-dark/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";
import { formatBytes } from "../utils/utils";

interface FileCardProps {
  file: File;
  progress?: number;
  disabled?: boolean;
  onRemove: () => void;
  dropzoneWidth?: string;
}

const StyledCard = styled(MDBox)<{ dropzoneWidth?: string }>`
  width: ${({ dropzoneWidth }) => dropzoneWidth || "100%"};
  background: ${colors.background.default};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 1rem;
  border: 1px solid ${colors.grey[300]};
`;

export function FileCard({ file, progress, disabled, onRemove, dropzoneWidth }: FileCardProps) {
  return (
    <StyledCard dropzoneWidth={dropzoneWidth}>
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <DescriptionIcon
          sx={{
            width: 40,
            height: 40,
            minWidth: 40,
            minHeight: 40,
            color: colors.grey[500],
          }}
        />
        <MDBox
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            gap: "2px",
          }}
        >
          <MDTypography
            sx={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              fontSize: "1rem",
              fontWeight: 500,
              color: colors.text.main,
            }}
          >
            {file.name}
          </MDTypography>
          <MDTypography
            sx={{
              fontSize: "0.875rem",
              color: colors.grey[500],
            }}
          >
            {formatBytes(file.size)}
          </MDTypography>
          {progress ? <MDProgress value={progress} sx={{ mt: 1 }} /> : null}
        </MDBox>
        <MDButton
          onClick={onRemove}
          disabled={disabled}
          variant="contained"
          color="error"
          sx={{ width: pxToRem(28), height: pxToRem(30), minWidth: 0, padding: 0 }}
        >
          <CloseIcon sx={{ fontSize: pxToRem(20) }} />
        </MDButton>
      </MDBox>
    </StyledCard>
  );
}
